import React, { useEffect, useRef, useState } from 'react'
import './manage-content.styles.scss';

import { useNavigate } from 'react-router-dom';
import { getMyContentFromDb, getPackageFromDb } from '@/utils/getDataFromDb';
import { getOrgsFromDb } from '@/utils/getAdminData';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import ContentListItem from './content-list-item.component';
import { ModalAlert } from '@/components/modal/modal.component';
import AdminAddElementModal from './add-element-modal.component';

const ManageContent = ({
  owners,
}) => {

  const [orgList, setOrgList] = useState(null);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packageList, setPackageList] = useState(null);
  const [contentToDisplay, setContentToDisplay] = useState(null);
  const [info, setInfo] = useState(null);
  const [elementTypes, setElementTypes] = useState(null);
  const [selectedElementType, setSelectedElementType] = useState(null);
  const [displayCount, setDisplayCount] = useState(10);
  const [showAddElementModal, setShowAddElementModal] = useState(false);
  const [ contentContainer, setContentContainer ] = useState(null);
  const [contentType, setContentType] = useState(null);
  const [ alertMessage, setAlertMessage ] = useState(null);
  const navigate = useNavigate();
  const orgListRef = useRef();
  let orgListener;

  useEffect(() => {
    getOrgs();
    getPackages();


    return () => {
      if (orgListener) orgListener();
    }
  }, [])

  async function getOrgs() {
    getOrgsFromDb({
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      orgListRef.current = {
        ...orgListRef.current,
        ...{ [data.orgId]: data }
      }
      setOrgList(orgListRef.current);
    }
    function handleListener(unsub) {
      orgListener = unsub;
    }
  }

  async function getPackages() {
    getPackageFromDb({
      'callback': callback,
    });
    function callback(data) {
      setPackageList(data);
    }
  }

  function chooseContent(e) {
    const methodObj = {
      'owner': () => {
        setSelectedOwner(e.value);
        setSelectedOrganization(null);
        setSelectedPackage(null);
      },
      'org': () => {
        setSelectedOwner(null);
        setSelectedOrganization(e.value);
        setSelectedPackage(null);
      },
      'pkg': () => {
        setSelectedOwner(null);
        setSelectedOrganization(null);
        setSelectedPackage(e.value);
      }
    }
    const method = e.type;
    methodObj[method]();
    setContentType(e.type);
    setContentContainer(e.value);
    if (e.type === 'pkg') {
      getPackageFromDb({
        'packageId': e.value,
        'callback': callback,
      })
    } else {
      getMyContentFromDb({
        'appId': e.value,
        'callback': callback,
        'once': true
      })
    }
    function callback(data) {
      console.log(data);
      if (!data) return;
      if (data && data['00_info']) {
        setInfo(data['00_info']);
        delete data['00_info'];
      } else if (e.type === 'org') {
        setInfo({
          'name': orgList[e.value].name,
          'id': e.value,
          'icon': orgList[e.value].icon,
          'type': 'org'
        });
      } else if (e.type === 'owner') {
        setInfo({
          'fName': owners[e.value].fName,
          'lName': owners[e.value].lName,
          'name': owners[e.value].lName + ', ' + owners[e.value].fName,
          'id': e.value,
          'icon': owners[e.value].icon,
          'type': 'owner'
        });
      }
      setContentToDisplay(data);
      const types = [...new Set(Object.values(data).map(item => item.type))];
      setElementTypes(types);
    }
  }

  return (
    <div className='admin-content-landing__content__sub'>
      <div className='buttons'>
        <button
          className='g-button med-btn'
          onClick={() => navigate('/admin/content/create')}>
          New Package
        </button>
        <button
          className='g-button med-btn'
          onClick={() => navigate('templategames')}>
          Template Games
        </button>
      </div>
      <div className="g-space-1"></div>
      <div className='content-grid'>
        <div className='field'>
          <label>Game Owner</label>
          <select
            value={selectedOwner ?? ''}
            onChange={e => chooseContent({
              'type': 'owner',
              'value': e.target.value
            })}>
            <option value=''>Select Game Owner</option>
            {
              (owners) &&
              Object.values(owners)
                .sort((a, b) => a.lName.toLowerCase() > b.lName.toLowerCase() ? 1 : -1)
                .map(owner => {
                  return (
                    <option key={owner.appId} value={owner.appId}>{owner.lName}, {owner.fName}</option>
                  )
                })
            }
          </select>
        </div>
        <div className='field'>
          <label>Organizations</label>
          <select
            value={selectedOrganization ?? ''}
            onChange={e => chooseContent({
              'type': 'org',
              'value': e.target.value
            })}>
            <option value=''>Select Organization</option>
            {
              (orgList) &&
              Object.values(orgList).map(org => {
                return (
                  <option key={org.orgId} value={org.orgId}>{org.name}</option>
                )
              })
            }
          </select>
        </div>
        <div className='field'>
          <label>Packages</label>
          <select
            value={selectedPackage ?? ''}
            onChange={e => chooseContent({
              'type': 'pkg',
              'value': e.target.value
            })}>
            <option value=''>Select Package</option>
            {
              (packageList) &&
              Object.keys(packageList).map(pkgId => {
                const pkg = packageList[pkgId];
                return (
                  <option key={pkgId} value={pkgId}>{pkg['00_info'].name}</option>
                )
              })
            }
          </select>
        </div>

      </div>
      <div className="g-space-1"></div>
      <div className='results'>
        {
          (info) &&
          <div className='info-box g-list-item'>
            <div className='info-box__icon'>
              {
                (info.type === 'pkg' || info.type === 'org')
                  ?
                  <ImageContainer
                    src={info.icon}
                    alt={info.name} />
                  :
                  <UserIcon
                    profile={info}
                    noHover={true} />
              }
            </div>
            <div>
              <div className='info-box__name'>
                <h3>{info.name}</h3>
              </div>
              <div className='info-box__id meta'>
                ID: {info.id}
              </div>
            </div>
            <div className='buttons'>
              <div className='field'>
                <select
                  value={selectedElementType ?? ''}
                  onChange={e => setSelectedElementType(e.target.value)}>
                  <option value=''>Select Element Type</option>
                  {
                    (elementTypes) &&
                    elementTypes
                      .sort()
                      .map(type => (
                        <option key={type} value={type}>{type}</option>
                      ))
                  }
                </select>
              </div>
              <button 
                className='g-button med-btn'
                onClick={() => setShowAddElementModal(true)}>
                <FontAwesomeIcon icon={faPlusCircle} /> Add Element
              </button>
            </div>
          </div>
        }
        <div className="g-space-1"></div>
        {
          (contentToDisplay && displayCount) &&
          <div className='content-list'>
            {
              Object.values(contentToDisplay)
                .filter(item => {
                  if (selectedElementType) {
                    return item.type === selectedElementType;
                  } else {
                    return false;
                  }
                })
                .map((item, index) => {
                  if (index >= displayCount) return null;
                  return (
                    <ContentListItem
                      contentItem={item} />
                  )
                })
            }
          </div>
        }
        <div className="g-space-1"></div>
        <div className='center-col'>
          {
            (contentToDisplay && selectedElementType && Object.values(contentToDisplay).filter(item => item.type === selectedElementType).length > displayCount) &&
            <button
              className='g-button med-btn'
              onClick={() => setDisplayCount(displayCount + 10)}
            >
              Load More...
            </button>
          }
        </div>
      </div>
      <AdminAddElementModal
        show={showAddElementModal}
        cancel={() => setShowAddElementModal(false)}
        contentType={contentType}
        contentContainer={contentContainer}
        alertMessage={alertMessage}
        setAlertMessage={setAlertMessage} />
      <ModalAlert
        show={!!alertMessage}
        message={alertMessage}
        cancel={() => setAlertMessage(null)}
      />
    </div>
  )
}

export default ManageContent